// removed by extract-text-webpack-plugin
module.exports = {"DropInfoDisplay":"DropInfoDisplay__-loca-__2Epbd","Image":"DropInfoDisplay__-loca-__2dM7-","TextGroup":"DropInfoDisplay__-loca-__2TIX3","Name":"DropInfoDisplay__-loca-__2lXJb","Variant":"DropInfoDisplay__-loca-__3-KIk","NumberAvailable":"DropInfoDisplay__-loca-__2420Y","Edition":"DropInfoDisplay__-loca-__1q-qs","TextGrid":"DropInfoDisplay__-loca-__2VRIy","Cost":"DropInfoDisplay__-loca-__1lBFK"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DropInfoDisplay/DropInfoDisplay.css
// module id = 117
// module chunks = 0